import { Media } from "@components/Media";
import SpecialCollectionMetadataTabs from "@modules/SpecialCollections/SpecialCollectionMetadataTabs";
import SpecialCollectionMetadataAccordion from "./SpecialCollectionMetadataAccordion";
import React, { Component } from "react";
import Overridable from "react-overridable";
import { Container } from "semantic-ui-react";
import PropTypes from "prop-types";

class SpecialCollectionMetadata extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    };
  }

  showTab = (activeTab) => {
    this.setState({ activeTab });
  };

  render() {
    const { metadata } = this.props;
    const { activeTab } = this.state;

    return (
      <Container className="document-metadata" data-test={metadata.pid}>
        <Media greaterThanOrEqual="tablet">
          <SpecialCollectionMetadataTabs
            metadata={metadata}
            activeTab={activeTab}
            showTab={this.showTab}
          />
        </Media>
        <Media at="mobile">
          <SpecialCollectionMetadataAccordion
            metadata={metadata}
            activeTab={activeTab}
            showTab={this.showTab}
          />
        </Media>
      </Container>
    );
  }
}

SpecialCollectionMetadata.propTypes = {
  metadata: PropTypes.object.isRequired,
};

export default Overridable.component(
  "SpecialCollectionMetadata",
  SpecialCollectionMetadata
);
